import React from 'react';

import { cn } from '../../lib/utils';
import Typography from '../../Typography/Typography';

export interface HeaderProps {
  title: string;
  subtitle: string;
  className?: string;
}

const Header: React.FC<HeaderProps> = ({
  title,
  subtitle,
  className
}) => {
  return (
    <div className={cn('flex flex-col items-center space-y-2', className)}>
      <Typography tag="h3" className="text-h3 font-semibold text-base-foreground text-center">
        {title}
      </Typography>
      <Typography className="text-p-s text-base-mutedForeground text-center">
        {subtitle}
      </Typography>
    </div>
  );
};

export default Header;

